import { markOptionsWithWarnings } from 'src/common/helpers/ConfigurationWarningsHelper';

export const markWfaOptionsWithWarnings = (
	options: Parameters<typeof markOptionsWithWarnings>[0],
	configuredValuesSet: Parameters<typeof markOptionsWithWarnings>[1],
	displayName: Parameters<typeof markOptionsWithWarnings>[2]
): ReturnType<typeof markOptionsWithWarnings> => {
	return markOptionsWithWarnings(options, configuredValuesSet, displayName);
};
